module.exports = "<div class=\"list-group\">\r\n  <a class=\"list-group-item list-group-item-primary\" routerLink=\"/reservations\">Kaarten</a>\r\n  <a class=\"list-group-item list-group-item-primary\" routerLink=\"/sale\">Verkoop</a>\r\n  <a class=\"list-group-item list-group-item-primary\" routerLink=\"/stock\">Stock</a>\r\n</div>\r\n"


//////////////////
// WEBPACK FOOTER
// C:/Users/krist/source/repos/FoodButtler.App/src/app/layout/header/header.component.html
// module id = ../../../../../src/app/layout/header/header.component.html
// module chunks = main